import Modal from "../Modals/Modal";
import withAlert from "../Alerts/withAlert";
import BaseErrorBoundaryWithRenderer from "./BaseErrorBoundaryWithRenderer";
import AuthenticationManager from "../Authentication/AuthenticationManager";
import NavigateToNonModalLocation from "../Routing/NavigateToNonModalLocation";

class ModalErrorBoundary extends BaseErrorBoundaryWithRenderer {
  render() {
    if (!this.state.hasError) return this.props.children;

    if (this.needsToSignIn) {
      return <AuthenticationManager onClose={this.handleModalClosed} />;
    }

    // GraphQL authorization errors can carry a user-facing notice. In modal routes, the
    // notice displayed by BaseErrorBoundary is the whole error UI, so the modal is left
    // instead of rendering a generic error page behind the alert.
    if (this.notice) {
      return <NavigateToNonModalLocation notice={this.notice} />;
    }

    return (
      <Modal shouldCloseOnOverlayClick={true} onRequestClose={this.props.onClose}>
        {this.renderErrorComponent()}
      </Modal>
    );
  }
}

export default withAlert(ModalErrorBoundary);
